<ng-container
  *appLet="{
    culture: (culture$ | async),
    featUS366IsOn: gbs.growthBook.isOn(gbf.FEAT_US366_DOHOP_V2_TOP_CONNECTIONS),
    featUS366Value: gbs.growthBook.getFeatureValue(
      gbf.FEAT_US366_DOHOP_V2_TOP_CONNECTIONS, ''
    )
  } as $comp"
>
  <div class="modal-header">
    <div *ngIf="isOrigin" class="modal-title">
      <span>{{ copy.whereFlyingFrom }}</span>
    </div>
    <div *ngIf="isDestination" class="modal-title">
      <span>{{ copy.whereFlyingTo }}</span>
    </div>
    @if (customTitle) {
      <div class="modal-title">
        <span>{{ customTitle }}</span>
      </div>
    }
    <button
      id="btnClose"
      type="button"
      class="btn-close close float-end"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-search">
    <div
      [ngClass]="{
        'visually-hidden':
          (ffs.isFeatureActive(ffe.CONNECTIONS) &&
          $comp.featUS366IsOn &&
          ($comp.featUS366Value === 'b' || $comp.featUS366Value === 'c')
            ? false
            : isDestination || !(shouldUseMobileStyling | async)) && !showInput
      }"
      class="px-3 station-search"
    >
      <input
        #origin
        class="form-control"
        type="text"
        [formControl]="searchStationCtrl"
        placeholder="Enter an airport, city or country"
      />
    </div>
  </div>
  <div class="modal-body">
    @if (norseStations().length > 0) { @if (showDohop && !!dohopStations().length && ffs.isFeatureActive(ffe.CONNECTIONS)
      && $comp.featUS366IsOn && ($comp.featUS366Value === 'b' || $comp.featUS366Value === 'c')) {
        <div class="row">
      <div class="col oversize py-2">
        <a
          class="toggle-container"
          role="button"
          [ngClass]="{ collapsed: collapse.norse }"
          [attr.aria-expanded]="!collapse.norse"
          [attr.aria-controls]="'oversized'"
          (click)="collapse.norse = !collapse.norse"
        >
          <i class="toggle-chevron"></i>
          <p>{{ copy.connectionsWidgetContentTitleOne }}</p>
        </a>
      </div>
    </div>
    }
    <div class="station-list" [collapse]="collapse.norse">
      <div class="container">
        @for (continent of norseStations() | continentStationZone; track
        continent.zoneCode) {
        <div class="row station-group">
          <div class="col m-auto">
            <div class="station-fullname">{{ continent.zoneCodeName }}</div>
          </div>
        </div>
        @for (station of continent.stations; track station.stationCode) {
        <div class="row pointer" (mousedown)="onStationSelect(station)">
          <div class="col-2 m-auto">
            <div class="station-flag text-center">
              <img
                src="{{
                  'https://assets.flynorse.com/static/site/flags/circular/' +
                    station?.locationDetails?.countryCode?.toLowerCase() +
                    '.svg'
                }}"
                width="15px"
                class="rounded-circle"
              />
            </div>
          </div>
          <div class="col-8 m-auto">
            <div class="station-fullname">{{ station?.fullName }}</div>
          </div>
          <div class="col-2 m-auto text-end">
            <div class="station-code">
              {{ getMacOverride(station?.stationCode) }}
            </div>
          </div>
        </div>
        } }
      </div>
    </div>
    }
    @if (showDohop && ffs.isFeatureActive(ffe.CONNECTIONS) && $comp.featUS366IsOn &&
    ($comp.featUS366Value === 'b' || $comp.featUS366Value === 'c')) { @if (dohopStations().length > 0) {
      @if (!!norseStations().length) {
        <div class="row">
          <div class="col oversize pb-2 pt-4">
            <a
              class="toggle-container"
              role="button"
              [ngClass]="{ collapsed: collapse.dohop }"
              [attr.aria-expanded]="!collapse.dohop"
              [attr.aria-controls]="'oversized'"
              (click)="collapse.dohop = !collapse.dohop"
            >
              <i class="toggle-chevron"></i>
              <p>{{ copy.connectionsWidgetContentTitleTwo }}</p>
            </a>
            <span class="badge fs-6 ms-2 px-1 bg-color-lt-teal">{{ copy.connectionsWidgetContentTitleTwoText }}</span>
          </div>
        </div>
      }
    <div class="station-list" [collapse]="collapse.dohop">
      <div class="container">
        @for (continent of dohopStations() | continentStationZone; track
        continent.zoneCode) {
        <div class="row station-group">
          <div class="col m-auto">
            <div class="station-fullname">{{ continent.zoneCodeName }}</div>
          </div>
        </div>
        @for (station of continent.stations; track station.stationCode) {
        <div class="row pointer" (mousedown)="onStationSelect(station)">
          <div class="col-2 m-auto">
            <div class="station-flag text-center">
              <img
                src="{{
                  'https://assets.flynorse.com/static/site/flags/circular/' +
                    station?.locationDetails?.countryCode?.toLowerCase() +
                    '.svg'
                }}"
                width="15px"
                class="rounded-circle"
              />
            </div>
          </div>
          <div class="col-8 m-auto">
            <div class="station-fullname">{{ station?.fullName }}</div>
          </div>
          <div class="col-2 m-auto text-end">
            <div class="station-code">
              {{ getMacOverride(station?.stationCode) }}
            </div>
          </div>
        </div>
        } }
      </div>
    </div>
    } }
  </div>
  @if ( ($comp.culture === "en-US" || $comp.culture === "en-GB") && !hideHelpInfo ) {
  <ng-container
    *appLet="{
      featIsOn176: gbs.isOn(gbf.FEAT_US176_DOHOP_LINK),
      featStringValue176: gbs.getFeatureStringValue(gbf.FEAT_US176_DOHOP_LINK)
    } as $growthbookDohopLinkComp"
  >
    @if ( $growthbookDohopLinkComp.featIsOn176 &&
    $growthbookDohopLinkComp.featStringValue176 !== 'a' ) {
    <div
      class="modal-footer"
      [innerHTML]="dohopFooterContent | safeHtml: SanitizerValueType.HTML"
    ></div>
    }
  </ng-container>
  }
</ng-container>
